<div class="overlay-form">
  <div class="header-content d-flex align-items-center justify-content-between">
    <div>
      <div class="d-flex">
        <h1>Place your Bid</h1>
        @if (bidCount() < 3 && bidCount() > 0) {
          <span class="bid-count">
            {{ bidCount() }}
            {{ bidCount() > 1 ? ' Bids' : ' Bid' }} left
          </span>
        }
      </div>

      <caption class="mt-2 d-none d-sm-none d-md-none d-lg-block d-xl-block d-xxl-block">
        Start placing your Bid and get exciting discounted amount
      </caption>
    </div>

    <img (click)="ref.close()" [src]="IMAGE_URLS.closeIconDark" class="clickable" />
  </div>
  
  <div class="overlay-content">
    @for (chatLog of systemUserChatLog(); track chatLog) {
      @switch (chatLog.responder) {
        @case (ChatResponder.System) {
          <div class="chat-container d-flex justify-content-start" #systemChat>
            <span
              [class.is-offer-available]="chatLog?.offerAccepted"
              [innerHTML]="chatLog.message"
            ></span>
          </div>
        }
        @case (ChatResponder.User) {
          <div class="user-chat-container d-flex justify-content-end" #userChat>
            <span> {{ chatLog.message }} </span>
          </div>
        }
      }
    }
    
    @if (loading()) {
      <div class="chat-container d-flex justify-content-start">
        <span>
          <base-loader-dot></base-loader-dot>
        </span>
      </div>
    }
  </div>

  <div class="overlay-footer">
    <!-- initial state -->
    @if (showBiddingInput()) {
      <div class="row">
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0">
          <h3 class="title-header">Selling price: {{ sellingPrice() | indianCurrency }}</h3>
          <p class="small-text">
            You have only {{ bidCount() }}{{ bidCount() > 1 ? ' Bids' : ' Bid' }} available
          </p>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0">
          <div class="bid-input-container">
            <input
              class="bid-input-box"
              type="text"
              placeholder="Enter amount"
              [formControl]="bidInput"
              (keydown.enter)="!loading() ? sendCustomerBid() : null"
            />
            <base-button-sm
              type="button"
              class="bid-btn"
              (click)="sendCustomerBid()"
              [disabled]="bidCount() <= 0"
              [loading]="loading()"
            >
              Bid
            </base-button-sm>
          </div>
        </div>
      </div>
    }

    <!-- after first bid show this -->
    @if (!showBiddingInput()) {
      <div
        class="row text-center text-sm-center text-md-start text-lg-start text-xl-start text-xxl-start"
      >
        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
          @if (bidCount() > 0) {
            <base-outline-button-sm (click)="toggleBiddingInput()">
              {{ biddingDetails().is_acceptable ? 'Not interested' : 'Place new Bid' }}
            </base-outline-button-sm>
          }
          @if (bidCount() <= 0) {
            <base-outline-button-sm (click)="startTheBidAgain()">
              Start Again
            </base-outline-button-sm>
          }
        </div>
        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
          <base-button-sm (click)="submitTheBid()">
            {{ biddingDetails().is_acceptable ? 'Yes, interested' : 'Accept this Offer' }}
          </base-button-sm>
        </div>
      </div>
    }
  </div>
</div>
